import { defineMessages } from 'react-intl';

export default defineMessages({
  querySubstituted: {
    id: 'frontbucket.search.querySubstitutedWarning.querySubstituted',
    description:
      'Warning that query was invalid and the search was run with a different query',
    defaultMessage: `We couldn't parse your query but we've returned results that match parts of the query.`,
  },
  learnMoreLink: {
    id: 'frontbucket.search.querySubstitutedWarning.learnMore',
    description: 'Link to documentation about search',
    defaultMessage: 'Learn more about search queries',
  },
});
